import $ from 'jquery';

export default function articlesModule() {
  const articlesElement = $('.stage-articles, .pointshop-card, .article, .expert-articles');
  if (articlesElement.length) {
    return import(/* webpackChunkName: "articles" */ '../articles')
      .then(({ default: Articles }) => {
        const articles = new Articles();
        return articles;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
